<nz-result
    nzStatus="404"
    nzTitle="404"
    nzSubTitle="{{ 'MISCELLANEOUS.404' | translate }}"
>
    <div nz-result-extra>
        <button nz-button nzType="primary" routerLink="/">
            {{ 'MISCELLANEOUS.BUTTON' | translate }}
        </button>
    </div>
</nz-result>
